import * as React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Button from "@mui/joy/Button";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import IconButton from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";
import BookmarkAdd from "@mui/icons-material/BookmarkAddOutlined";
import { setSelectedGate, updateField } from "../../utils/customerSlice";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/joy";

export default function GateStyleCard({ data, type }) {
  const dispatch = useDispatch();
  const selectedGate = useSelector((state) => state.customer.selectedGate);
  const company = useSelector((state) => state.customer.company);
  const catalogGateMap = company ? company.catalogGateMap : {};
  const globalGateItemsMap = useSelector(
    (state) => state.company.globalGateItemsMap
  );
  const globalGateAttributesMap = useSelector(
    (state) => state.company.globalGateAttributesMap
  );

  const handleSelectStyle = (itemId, remove = false) => {
    switch (type) {
      case "style":
        dispatch(setSelectedGate({ style: data }));
        break;

      case "material":
        dispatch(
          setSelectedGate({ style: selectedGate.style, material: data })
        );
        break;

      case "attribute":
        if (remove) {
          // remove item from attributesMap
          const newAttributesMap = { ...selectedGate.attributesMap };
          delete newAttributesMap[data.id];

          dispatch(
            setSelectedGate({
              style: selectedGate.style,
              material: selectedGate.material,
              attributesMap: newAttributesMap,
            })
          );
        } else {
          dispatch(
            setSelectedGate({
              style: selectedGate.style,
              material: selectedGate.material,
              attributesMap: {
                ...selectedGate.attributesMap,
                [data.id]: {
                  attribute: data,
                  id: data.id,
                  item: globalGateItemsMap[itemId],
                },
              },
            })
          );
        }
        break;

      default:
        break;
    }
  };

  if (!data) {
    console.log("NO DATA");
    return null;
  }

  return (
    <Card
      sx={
        type === "attribute"
          ? {
              width: "100%",
            }
          : {
              width: {
                xs: "calc(100% - 1rem)",
                sm: "calc(50% - 1rem)",
                md: "calc(33.3333% - 1rem)",
                lg: "calc(25% - 1rem)",
              },
              maxWidth: "400px",
            }
      }
    >
      <div>
        <Typography level="title-lg">{data.name}</Typography>
        {data.type && (
          <Typography level="body-sm">type: {data.type}</Typography>
        )}
        <IconButton
          aria-label="bookmark gate type"
          variant="plain"
          color="neutral"
          size="sm"
          sx={{ position: "absolute", top: "0.875rem", right: "0.5rem" }}
        >
          <BookmarkAdd />
        </IconButton>
      </div>
      {data.imageUrl && (
        <AspectRatio minHeight="120px" maxHeight="200px">
          <img src={data.imageUrl} loading="lazy" alt="" />
        </AspectRatio>
      )}
      <CardContent orientation="horizontal">
        <div>
          {data.totalPrice && (
            <Typography level="body-xs">Total price:</Typography>
          )}
        </div>
        {type === "attribute" && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              overflowX: "auto",
              gap: 1,
            }}
          >
            {catalogGateMap[selectedGate.style.id].materialsGateMap[
              selectedGate.material.id
            ].attributesGateMap[data.id].itemsGateList.map((itemId) => {
              return (
                <Button
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: 100,
                  }}
                  variant={
                    selectedGate.attributesMap &&
                    selectedGate.attributesMap[data.id] &&
                    itemId === selectedGate.attributesMap[data.id].item.id
                      ? "solid"
                      : "outlined"
                  }
                  onClick={() =>
                    handleSelectStyle(
                      itemId,
                      selectedGate.attributesMap &&
                        selectedGate.attributesMap[data.id] &&
                        itemId === selectedGate.attributesMap[data.id].item.id
                    )
                  }
                >
                  <span> {globalGateItemsMap[itemId].name}</span>
                  <span>
                    $
                    {
                      catalogGateMap[selectedGate.style.id].materialsGateMap[
                        selectedGate.material.id
                      ].attributesGateMap[data.id].itemsGateMap[itemId].price
                    }
                  </span>
                </Button>
              );
            })}
          </Box>
        )}
        {type !== "attribute" && (
          <Button
            onClick={handleSelectStyle}
            variant="solid"
            size="md"
            color="primary"
            aria-label="select attribute"
            sx={{ ml: "auto", alignSelf: "center", fontWeight: 600 }}
          >
            Select
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
